const sortByOptionsForTreatmentServices = [
  {
    name : "recentlyUpdated",
    value: "1",
  },
  {
    // name: "Agency Name(A to Z)",
    name : "agencyNameAtoZ",
    value: "2",
  },
  {
    //name: "Agency Name(Z to A)",
    name : "agencyNameZtoA",
    value: "3",
  },
  {
    //name: "Distance From You",
    name : "distanceFromYou",
    value: "6",
  },
  {
    //name: "Distance From Your Zip Code",
    name : "distanceFromYourZipCode",
    value: "7",
  },
  {
    //name: "Walk-Ins Only",
    name : "walkInsOnly",
    value: "8",
  },
  {
    //name: "Spanish Language Services First",
    name : "spanishLanguageServicesFirst",
    value: "9",
  },
]

const sortByOptionsForOtherSerivces = [
  {
    //name: "Distance From You",
    name : "distanceFromYou",
    value: "6",
  },
  {
    //name: "Distance From Your Zip Code",
    name : "distanceFromYourZipCode",
    value: "7",
  },
]

const TREATMENT_SERVICE_ID = "3";

const getSortByOptions = (serviceId) => {
  if(serviceId === TREATMENT_SERVICE_ID) {
    return sortByOptionsForTreatmentServices;
  }
  return sortByOptionsForOtherSerivces;
}

export default getSortByOptions;